import { useCurrentStateAndParams } from "@uirouter/react";

import { SI_SEARCH_ROUTES } from "app/common/constants/ad-intelligence-routes";
import { ROUTES } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingConstants";

export interface IPagesEndpoints {
    table: string;
    enrichTable: string;
    graph: string;
    graphExcel: string;
    domains: string;
    categories: string;
}

const keywordResearchPagesEndpoints: IPagesEndpoints = {
    table: "api/KeywordAnalysis/Pages/Table",
    enrichTable: "api/KeywordAnalysis/Pages/KeywordsDrillDown",
    graph: "api/KeywordAnalysis/Pages/Trend",
    graphExcel: "api/KeywordAnalysis/Pages/Trend/Excel",
    domains: "api/KeywordAnalysis/Pages/Domains",
    categories: "api/KeywordAnalysis/Pages/Categories",
};

const searchAdvertisingPagesEndpoints: IPagesEndpoints = {
    table: "api/AdIntelligence/Search/Pages/Table",
    enrichTable: "api/AdIntelligence/Search/Pages/KeywordsDrillDown",
    graph: "api/AdIntelligence/Search/Pages/Trend",
    graphExcel: "api/AdIntelligence/Search/Pages/Trend/Excel",
    domains: "api/AdIntelligence/Search/Pages/Domains",
    categories: "api/AdIntelligence/Search/Pages/Categories",
};

const pagesEndpointsMap: Record<string, IPagesEndpoints> = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    organicsearch_trafficAnalysis_2: keywordResearchPagesEndpoints,
    [ROUTES.keywordLandingPages]: searchAdvertisingPagesEndpoints,
    // Sales Intelligence mirror of Search Advertising.
    [SI_SEARCH_ROUTES.keywordLandingPages]: searchAdvertisingPagesEndpoints,
};

export const usePagesEndpoints = (): IPagesEndpoints => {
    const { state } = useCurrentStateAndParams();
    const endpoints = pagesEndpointsMap[state.name];

    if (!endpoints) {
        throw new Error(
            `No pages endpoints configured for state: ${state.name}. ` +
                `Available states: ${Object.keys(pagesEndpointsMap).join(", ")}`,
        );
    }

    return endpoints;
};
